<script lang="ts">
  import CloseIcon from './CloseIcon.svelte'
</script>

<button type="button" on:click class="absolute right-0 p-4 hover:opacity-75" aria-label="Close">
  <CloseIcon />
</button>
